module.exports = __webpack_public_path__ + "img/telephone-outbound.685ca159.svg";